import { Component,ComponentFactoryResolver } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as $ from 'jquery';
import * as AOS from 'aos';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  title = 'الصفحة الرئيسية';
  lang =  this.cookie_s.get("lang");

  constructor(
    private router: Router,
    private titleService: Title,
    translate: TranslateService,
    private cookie_s: CookieService
            ) {
      translate.setDefaultLang('en');
      if(!this.lang) this.cookie_s.set("lang", "en", undefined, "/");
      translate.use(this.lang || 'en');
              }

  ngOnInit()
  {
    AOS.init();

    this.titleService.setTitle(this.title);

    this.router.events.subscribe((evt) => {
        if (!(evt instanceof NavigationEnd)) {
            return;
        }
        $("html, body").animate({ scrollTop: 0 }, 100);
    });


    document.getElementsByTagName('html')[0].setAttribute('dir', this.lang == 'ar' ? 'rtl' : 'ltr');
    document.getElementsByTagName('html')[0].setAttribute('lang', this.lang || 'en');
  }



  whatsapp_chat()
  {
    window.open('https://wa.me/201141087755' , '_blank')
  }




  // stupid way, change tis later
  check_home_page() : boolean
  {

    if ( document.location.pathname == '/home' )
    {
      return true;
    }
    else
    {
      return false;
    }


  }





}
